<template>
	<AppDialog :closeRight="'-10'" :closeTop="'-30'" disableMaxWidth :dialogName="'installationComplete'" width="840px">
		<div class="dialog-content rounded">
			<InstallationCompleteContent class="complete" :wfId="wfId" />
		</div>
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import InstallationCompleteContent from '@/views/InstallationCompleteContent.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
export default {
	name: 'InstallationCompleteDialog',
	components: {
		AppDialog,
		InstallationCompleteContent,
	},
	props: {
		wfId: { type: Number },
		dialogPromiseHandlers: { type: Object },
	},
	computed: {},
	methods: {
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
	},
};
</script>

<style scoped lang="scss">
.dialog-content {
	height: 840px;
	background: var(--white);
}

.rounded {
	border-radius: 10px;
}
</style>
